import {
  GetLiveShoppingOverviewPageRequest,
  PagesServiceClientImpl,
} from '../../grpc_client/grips/protos/pages/v1/pages_service';
import {
  DefaultGRPCClientChannel,
  DefaultGRPCServerChannel,
} from '../../utils/grpc/grpc-client-channel';
import {GripsConfigOptions} from '../../utils/grpc/grpc-config';
import {sectionMapper} from './util/sectionMapper';

type OverviewQueryOptions = GripsConfigOptions;

function getChannel({
  isSSR,
  hostname,
  debug,
}: {
  isSSR: boolean;
  hostname: string;
  debug: boolean;
}) {
  return isSSR
    ? new DefaultGRPCServerChannel(hostname, debug)
    : new DefaultGRPCClientChannel(hostname, debug);
}

export async function getLiveShoppingOverviewPage({
  hostname,
  debug = false,
  childShopId,
  shopId,
  device,
  isSSR = false,
  gender,
}: OverviewQueryOptions) {
  const channel = getChannel({isSSR, hostname, debug});

  const options: GetLiveShoppingOverviewPageRequest = {
    config: {
      childShopId,
      shopId,
      device,
    },
    gender,
  };

  const client = new PagesServiceClientImpl(channel);

  const response = await client.GetLiveShoppingOverviewPage(options);
  const sections = sectionMapper(response.sections);

  return {
    ...response,
    sections,
  };
}
